// extracted by mini-css-extract-plugin
module.exports = {"root":"tv-lottery-answers_root__y6C8d","question":"tv-lottery-answers_question__H6Yjz","answers":"tv-lottery-answers_answers__ivaZc"};